import LightTheme from './light'
import DarkTheme from './dark'
import ExtraDarkTheme from './extradark'
import GreenTheme from './green'
import SpotifyTheme from './spotify'
import LigeraTheme from './ligera'
import MonokaiTheme from './monokai'
import ElectricPurpleTheme from './electricPurple'
import NordTheme from './nord'
import GruvboxDarkTheme from './gruvboxDark'
import CatppuccinFrappeTheme from './catppuccinFrappe'
import CatppuccinMacchiatoTheme from './catppuccinMacchiato'
import CatppuccinMochaTheme from './catppuccinMocha'
import CatppuccinLatteTheme from './catppuccinLatte'
import DraculaTheme from './dracula'
import NuclearTheme from './nuclear'
import NutballTheme from './nutball'
import RosePineTheme from './rosePine'
import RosePineDawnTheme from './rosePineDawn'
import RosePineMoonTheme from './rosePineMoon'
import AmusicTheme from './amusic'
import SquiddiesGlassTheme from './SquiddiesGlass'
import NautilineTheme from './nautiline'
import MoonbaseAlphaTheme from './moonbaseAlpha'
import MoonbaseBravoTheme from './moonbaseBravo'
import TokyoNightLightTheme from './tokyoNightLight'
import TokyoNightTheme from './tokyoNight'

export default {
  // Classic default themes
  LightTheme,
  DarkTheme,

  // New themes should be added here, in alphabetic order
  AmusicTheme,
  CatppuccinFrappeTheme,
  CatppuccinLatteTheme,
  CatppuccinMacchiatoTheme,
  CatppuccinMochaTheme,
  DraculaTheme,
  ElectricPurpleTheme,
  ExtraDarkTheme,
  GreenTheme,
  GruvboxDarkTheme,
  LigeraTheme,
  MonokaiTheme,
  MoonbaseAlphaTheme,
  MoonbaseBravoTheme,
  NautilineTheme,
  NordTheme,
  NuclearTheme,
  NutballTheme,
  RosePineDawnTheme,
  RosePineMoonTheme,
  RosePineTheme,
  SpotifyTheme,
  SquiddiesGlassTheme,
  TokyoNightLightTheme,
  TokyoNightTheme,
}
